import type { LongFormSection } from './types';

export const LONG_FORM_SECTION_STATUS = {
  active: 'active',
  archived: 'archived',
  generating: 'generating',
};

export const LONG_FORM_SECTION_TEXT_STATUS = {
  empty: 'empty',
  draft: 'draft',
  bullets: 'bullets',
  completed: 'completed',
  improved: 'improved',
  keptTheSame: 'kept_the_same',
  edited: 'edited',
  accepted: 'accepted',
  previouslyAccepted: 'previously_accepted',
  doneWithErrors: 'done_with_errors', // should be treated as `kept_the_same` for now - means that there were errors during section content generation, and it was not improved
};
export type LongFormSectionTextStatus =
  (typeof LONG_FORM_SECTION_TEXT_STATUS)[keyof typeof LONG_FORM_SECTION_TEXT_STATUS];

export const isLongFormSectionGenerating = (section: LongFormSection): boolean => {
  return section?.status === LONG_FORM_SECTION_STATUS.generating;
};

/**
 * Check if section is "accepted" currently
 * @param {Object} section
 * @returns {boolean}
 */
export const longFormSectionIsAccepted = (section: LongFormSection): boolean => {
  return section?.textStatus === LONG_FORM_SECTION_TEXT_STATUS.accepted;
};

/**
 * Check if section was already "accepted" in the past
 */
export const longFormSectionWasAlreadyAccepted = (section: LongFormSection): boolean => {
  return [
    LONG_FORM_SECTION_TEXT_STATUS.accepted,
    LONG_FORM_SECTION_TEXT_STATUS.previouslyAccepted,
  ].includes(section?.textStatus);
};

/**
 * Check if section is newly generated and was not edited/accepted yet
 */
export const longFormSectionIsNewlyGenerated = (section: LongFormSection): boolean => {
  return (
    section?.textStatus === LONG_FORM_SECTION_TEXT_STATUS.improved ||
    longFormSectionTextStatusKeptTheSame(section?.textStatus)
  );
};

/**
 * Check if section text status is "kept the same"
 */
export const longFormSectionTextStatusKeptTheSame = (
  textStatus: LongFormSectionTextStatus
): boolean => {
  return [
    LONG_FORM_SECTION_TEXT_STATUS.keptTheSame,
    LONG_FORM_SECTION_TEXT_STATUS.doneWithErrors,
  ].includes(textStatus);
};
